document.querySelectorAll('main h2, article time').forEach((el) => {
    el.innerHTML = `<span>${el.innerHTML}</span>`;
});

const sharone = window.sharone || {};

if ((sharone.$toggle = document.getElementById('menu-toggle'))) {
    sharone.menuOpenClass = 'menu-open';

    sharone.closeMenuOnEsc = (event) => {
        event = event || window.event;

        if (event.keyCode == 27) {
            sharone.toggleMenu();
        }
    };

    sharone.closeMenuOnOutsideClick = (event) => {
        if (typeof event.target.closest === 'undefined') {
            return;
        }

        if (
            event.target.closest('#menu-toggle') ||
            event.target.closest('#menu')
        ) {
            return;
        }

        sharone.toggleMenu();
    };

    sharone.toggleMenu = () => {
        document.body.classList.toggle(sharone.menuOpenClass);

        if (document.body.classList.contains(sharone.menuOpenClass)) {
            document.addEventListener('keydown', sharone.closeMenuOnEsc);
            document.addEventListener('click', sharone.closeMenuOnOutsideClick);
        } else {
            document.removeEventListener('keydown', sharone.closeMenuOnEsc);
            document.removeEventListener(
                'click',
                sharone.closeMenuOnOutsideClick,
            );
        }
    };

    sharone.$toggle.addEventListener('click', (e) => {
        e.preventDefault();
        sharone.toggleMenu();
    });
}

sharone.init = () => {
    document.querySelectorAll('.lazy-image-wrapper').forEach((wrapper) => {
        const img = wrapper.querySelector('img');
        const lazySrc = img.getAttribute('lazy-src');
        const lazySrcSet = img.getAttribute('lazy-srcset');

        if (lazySrc || lazySrcSet) {
            img.onload = () => {
                wrapper.classList.add('lazy-image-loaded');
            };
        }

        if (lazySrc) {
            img.src = lazySrc;
        }

        if (lazySrcSet) {
            img.srcset = lazySrcSet;
        }
    });
};

window.onload = sharone.init;

const reps = document.querySelectorAll('.representation');

if (reps.length > 0) {
    const parentNode = reps[0].parentNode;

    const wrapper = document.createElement('div');

    wrapper.classList.add('representation-wrapper');

    parentNode.insertBefore(wrapper, reps[0]);

    reps.forEach((rep) => {
        wrapper.appendChild(rep);
    });
}
